module.exports = __webpack_public_path__ + "img/Asset115.f3e97932.png";